import * as FingerprintJS from '@fingerprintjs/fingerprintjs';
import { generateSimpleFingerprint } from './fallbackFingerprinting';

// Define proper types for FingerprintJS
type FingerprintAgent = FingerprintJS.Agent;
type FingerprintResult = {
  visitorId: string;
  components: Record<string, unknown>;
};

// Initialize the fingerprinting agent
let fpPromise: Promise<FingerprintAgent> | null = null;

export const getVisitorId = async (): Promise<string> => {
  try {
    if (!fpPromise) {
      fpPromise = FingerprintJS.load();
    }

    const fp = await fpPromise;
    const result = await fp.get() as FingerprintResult;

    // The visitorId is a stable identifier that remains the same for the same browser
    return result.visitorId;
  } catch (error) {
    console.error('Error generating fingerprint, using fallback:', error);
    return generateSimpleFingerprint();
  }
};
